<template>
  <div v-if="content" :class="b({ view })">
    <div :class="b('content')" v-html="content" />
  </div>
</template>

<script src="./status.scripts.js" />

<style module src="./status.styles.scss" lang="scss" />
